import {Injectable, Type} from '@angular/core';
import {TaskStepTypeEnum} from '@dto/tasks/task-step-type.enum';
import {BaseTaskComponent} from './base-task-component';
import {AdaptiveCardTaskComponent} from './adaptive-card/adaptive-card-task.component';
import {FileTaskComponent} from './file/file-task.component';
import {GbgTaskComponent} from './gbg/gbg-task.component';
import {Validator} from '@shared/utilities/validator';

@Injectable({
  providedIn: 'root'
})
export class TaskComponentMappingService {

  public map(taskStepType: TaskStepTypeEnum): Type<BaseTaskComponent> {
    switch (taskStepType) {
      case TaskStepTypeEnum.AdaptiveCard:
        return AdaptiveCardTaskComponent;
      case TaskStepTypeEnum.FileDownload:
      case TaskStepTypeEnum.FileUpload:
        return FileTaskComponent;
      case TaskStepTypeEnum.GbgIdScan:
        return GbgTaskComponent;
    }

    Validator.verifySwitchHandledAllOptions(taskStepType);
  }
}
